module.exports = __webpack_public_path__ + "img/readCourse.a48661a5.svg";